<template>
    <fragment>
        <div v-if="enabled" class="flex items-center justify-center">
            <custom-switch
                v-model="enabledScanner"
                class="border border-dark w-28"
                @input="changeEnableScanner"
            >
                <template #off> Scanner off </template>
                <template #on> Scanner on </template>
            </custom-switch>

            <custom-tooltip border>
                <app-button icon @click="openModal"> 📠 </app-button>
                <template #tooltip>Ingreso de código de barras manual</template>
            </custom-tooltip>
        </div>
        <span v-else> Scanner off ⚪</span>

        <app-dialog v-model="isOpenModalManual" size="sm" @close="closeModal">
            <div>
                <span class="text-lg">Ingresa el código de barras</span>
                <div class="flex mt-2">
                    <custom-input
                        id="barcode"
                        v-model="barcode"
                        type="text"
                        name="barcode"
                        class="w-full mr-2"
                        aria-label="Barcode"
                        :disabled="isLoading"
                        @enter="onClickSearch"
                    />
                    <app-button
                        circle
                        icon
                        :loading="isLoading"
                        @click="onClickSearch"
                    >
                        🔎
                    </app-button>
                </div>
            </div>
        </app-dialog>
    </fragment>
</template>

<script>
import { stringRegex } from "@/common/lib/regex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "BarcodeScanner",
    components: { AppDialog, CustomInput },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => false,
            type: Boolean,
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change", "input"],
    data: () => ({
        enabledScanner: false,
        isLoading: false,
        wasActive: false,
        timer: null,
        barcode: "",
        isOpenModalManual: false
    }),
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleListener);
    },
    methods: {
        handleListener(event) {
            if (!this.enabledScanner || !stringRegex.test(event.key)) return;
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.barcode += `${event.key}`;
            this.timer = setTimeout(() => {
                if (this.barcode.length > 2) {
                    this.$emit("input", this.barcode);
                    this.isOpenModalManual = false;
                }
                this.barcode = "";
            }, 20);
        },
        startListener() {
            document.addEventListener("keydown", this.handleListener);
        },
        stopListener() {
            document.removeEventListener("keydown", this.handleListener);
        },
        changeEnableScanner() {
            this.$emit("change", this.enabledScanner);
        },
        openModal() {
            this.isOpenModalManual = true;
            this.enabledScanner = false;
            this.stopListener();
        },
        closeModal() {
            this.enabledScanner = true;
            this.startListener();
        },
        async onClickSearch() {
            try {
                this.$emit("input", this.barcode);
                this.isOpenModalManual = false;
            } catch (error) {
                this.isOpenModalManual = true;
                this.barcode = "";
            }
        },
        setInput(value) {
            this.enabledScanner = Boolean(value) && !this.$isPhone;
            if (value) {
                this.startListener();
            } else {
                this.stopListener();
            }
        }
    }
};
</script>
